// src/utils/columnsHelpers.tsx
export const getEditDeleteColumns = <T extends { id: string }>(
  onEdit: (item: T) => void,
  onDelete: (key: string) => void
) => [
  {
    title: 'Изменить',
    key: 'edit',
    render: (_: unknown, record: T) => (
      <button
        type="button"
        onClick={() => onEdit(record)}
        style={{ background: 'none', border: 'none', padding: 0, color: '#1677ff', cursor: 'pointer' }}
      >
        Изменить
      </button>
    ),
  },
  {
    title: 'Удалить',
    key: 'delete',
    render: (_: unknown, record: T) => (
      <button
        type="button"
        onClick={() => onDelete(record.id)}
        style={{ background: 'none', border: 'none', padding: 0, color: '#ff4d4f', cursor: 'pointer' }}
      >
        Удалить
      </button>
    ),
  },
];

export const originalColumn = {
  title: 'Тип товара',
  dataIndex: 'original',
  key: 'original',
  filters: [
    { text: 'Оригинал', value: 'original' },
    { text: 'Копия', value: 'copy' },
  ],
  onFilter: (value: any, record: any) =>
    String(record.original) === String(value),
  render: (val: string) => (val === 'original' ? 'Оригинал' : 'Копия'),
  sorter: (a: any, b: any) => a.original.localeCompare(b.original),
};
